import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { adminApi, setAdminSession } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { Lock, Mail, ShieldCheck, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@pramid.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminApi.post("/admin/login", { email, password });
      setAdminSession(res.data);
      toast.success(res.data.role === "staff" ? "Yetkili personel girişi başarılı." : "Yönetici girişi başarılı.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1E3A5F] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <button
          onClick={() => nav("/")}
          className="text-white/60 hover:text-white text-xs uppercase tracking-[0.15em] flex items-center gap-1.5 mb-6 transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Müşteri Girişine Dön
        </button>

        <Card className="bg-white border-0 rounded-lg shadow-2xl overflow-hidden">
          <div className="bg-[#F97316] h-1" />
          <div className="p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#1E3A5F] flex items-center justify-center rounded-sm">
                <ShieldCheck className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-[#4B5563]">
                  PRAMID
                </div>
                <h1 className="text-xl font-bold text-[#1E3A5F] tracking-tight">
                  Yönetici Paneli
                </h1>
              </div>
            </div>

            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label className="text-[11px] uppercase tracking-[0.1em] text-[#4B5563]">
                  <Mail className="inline w-3.5 h-3.5 mr-1 -mt-0.5" /> E-posta
                </Label>
                <Input
                  data-testid={ADMIN.emailInput}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-11 border-[#E2E8F0] focus-visible:ring-[#F97316] focus-visible:ring-offset-0"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-[11px] uppercase tracking-[0.1em] text-[#4B5563]">
                  <Lock className="inline w-3.5 h-3.5 mr-1 -mt-0.5" /> Şifre
                </Label>
                <Input
                  data-testid={ADMIN.passwordInput}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-11 border-[#E2E8F0] focus-visible:ring-[#F97316] focus-visible:ring-offset-0"
                />
              </div>
              <Button
                data-testid={ADMIN.loginBtn}
                type="submit"
                disabled={loading}
                className="w-full h-11 bg-[#F97316] hover:bg-[#EA580C] text-white uppercase tracking-wide text-sm"
              >
                {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
              </Button>
            </form>
          </div>
        </Card>

        <div className="text-center mt-6 text-xs text-white/50">
          Sadece yetkili personel erişebilir
        </div>
      </div>
    </div>
  );
}
